import { render, staticRenderFns } from "./CommentsForm.vue?vue&type=template&id=4d0d28a9&scoped=true"
import script from "./CommentsForm.vue?vue&type=script&lang=js"
export * from "./CommentsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d28a9",
  null
  
)

export default component.exports